module.exports = __webpack_public_path__ + "img/star.fb083790.svg";